import React from 'react';
import QuotesTable from './quotesTable';

export default function Quotes() {
	return (
		<div id="Quotes" className="tab-pane fade">
			<div className="row" id="settings-field">
				<div className="col-md-2 padding-right">
					<label className="input-label" htmlFor="quote_status">
						Quote Status
					</label>
					<select className="form-control" id="quote_status">
						<option>Open</option>
						<option>Pending</option>
						<option>Accepted</option>
						<option>All</option>
					</select>
				</div>
				<div className="col-md-2 padding-0">
					<label className="input-label" htmlFor="warehouse">
						Warehouse
					</label>
					<select className="form-control" id="warehouse">
						<option></option>
						<option>Head Office</option>
						<option>Main Warehouse</option>
					</select>
				</div>
			</div>
			<br />
			{/* <div className="panel panel-default">
				<div className="panel-body"> */}
			<QuotesTable />
			{/* </div>
			</div> */}
		</div>
	);
}
